import React, { useEffect } from 'react'
import { Text, View } from '../../../components/Themed'
import { titleTextSize } from '../../../constants/GlobalStyle'
import { Dimensions, Platform, TouchableOpacity } from 'react-native'
import { useDispatch } from 'react-redux'
import { largeTextSize } from '../../../constants/GlobalStyle'
import Colors from '../../../constants/Colors'
import { StyleSheet } from 'react-native'
import { useAppSelector } from '../../../state/hooks'
import { EvilIcons, MaterialCommunityIcons } from '@expo/vector-icons'
import { GiftCardType } from '../types'
import Formatter from '../../../helpers/Formatter'
import { cloudFunction } from '../../../firebase/functions'
import { useNavigation } from '@react-navigation/native'

export default function GiftCardOrderConfirmed({ goHome, setIsOrderConfirmedModalVisible }) {
	const { loadedData, webAppURL } = useAppSelector(state => state.data)
	const { selectedMethods, products, orderId } = useAppSelector(state => state.checkout)

	const product = products[0]
	const isGift = product.recipientType === GiftCardType.Gift
	const receiveText = selectedMethods.textMessage && selectedMethods.phoneString !== ''
	const receiveEmail = selectedMethods.email && selectedMethods.emailString !== ''

	const navigation = useNavigation<any>()

	const handleDone = () => {
		goHome()
		setIsOrderConfirmedModalVisible(false)
		if (Platform.OS === 'web') {
			navigation.replace('HomeStack', { screen: 'RestaurantSelect' })
		} else {
			navigation.reset({
				index: 0,
				routes: [{ name: 'HomeStack' }],
			})
		}
	}

	const notificationString = () => {
		let str = 'YOUR PURCHASE RECEIPT WILL BE SENT TO YOU VIA'
		if (receiveText) str += ' TEXT'
		if (receiveText && receiveEmail) str += ' AND '
		if (receiveEmail) str += 'EMAIL'
		return str
	}

	const giftNotificationString = () => {
		let str = `${isGift ? `YOUR GIFT RECIPIENT` : `YOU`} WILL RECEIVE A`
		if (receiveText) str += ' TEXT'
		if (receiveText && receiveEmail) str += ' AND'
		if (receiveEmail) str += ' EMAIL'
		str += ` NOTIFICATION WITH A ${Formatter.formatCurrency(product.amount / 100, 'CAD', 2)} GIFT CARD.`
		return str
	}

	const notificationText = notificationString()
	const giftNotificationText = giftNotificationString()

	useEffect(() => {
		console.log(
			`[GiftCards.views.GiftCardOrderConfirmed] Beginning to send receipts for order ${orderId}.`
		)

		const sendEmailReceipt = async () => {
			try {
				console.log('[GiftCards.views.GiftCardOrderConfirmed] Sending email receipt.')
				const response = await cloudFunction('v2_sendEmailReceiptTest', {
					userEmail: selectedMethods.emailString,
					receiptLink: webAppURL + '/receipt?receiptId=' + orderId,
					orgLogo: loadedData[global.org].logoDark ?? loadedData[global.org].logo,
					emailLogo: loadedData[global.org].emailLogo,
					orgName: loadedData[global.org].name,
					orgColor: global.orgColor2,
				})
				console.log('[GiftCards.views.GiftCardOrderConfirmed] Gift card receipt email sent.')
				console.log(response)
			} catch (error) {
				console.error('Error calling cloud function', error)
			}
		}
		const sendTextReceipt = async () => {
			try {
				console.log('[GiftCards.views.GiftCardOrderConfirmed] Sending text receipt.')
				const response = await cloudFunction('v2_sendTextReceipt', {
					userPhone: selectedMethods.phoneString,
					receiptLink: webAppURL + '/receipt?receiptId=' + orderId,
					organizationName: loadedData[global.org].name,
				})
				console.log('[GiftCards.views.GiftCardOrderConfirmed] Text receipt sent.')
				console.log(response)
			} catch (error) {
				console.error('Error calling cloud function', error)
			}
		}

		if (selectedMethods.email) sendEmailReceipt()
		if (selectedMethods.textMessage) sendTextReceipt()
	}, [])

	return (
		<View style={styles.container}>
			<Text style={[styles.mainHeader, { color: global.orgColor }]}>THANK YOU!</Text>
			<View style={styles.contentContainer}>
				<View style={[styles.rowContainer, { marginLeft: '-2.5%' }]}>
					<EvilIcons name="bell" size={titleTextSize * 1.95} color="#818181" />
					<Text style={[styles.orderConfirmationText, { marginLeft: 20 }]}>{notificationText}</Text>
				</View>
				<View style={[styles.rowContainer, { marginLeft: '-2.5%' }]}>
					<MaterialCommunityIcons name="gift-outline" size={titleTextSize * 1.95} color="#818181" />
					<Text style={[styles.orderConfirmationText, { marginLeft: 20 }]}>
						{giftNotificationText}
					</Text>
				</View>
				<TouchableOpacity
					style={[styles.doneButton, { backgroundColor: global.orgColor, marginBottom: 20 }]}
					onPress={handleDone}
				>
					<Text style={styles.buttonText}>
						{global.kiosk ? 'START NEW ORDER' : 'RETURN TO HOME'}
					</Text>
				</TouchableOpacity>
			</View>
		</View>
	)
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		alignItems: 'center',
		marginHorizontal: '10%',
		marginVertical: '10%',
		backgroundColor: '#fff',
		marginBottom: 30,
		justifyContent: 'space-between',
		maxHeight: Dimensions.get('window').height * 0.8,
	},
	contentContainer: {
		alignItems: 'flex-start',
		justifyContent: 'center',
		flex: 1,
	},
	rowContainer: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-start',
		marginVertical: '8%',
	},
	orderConfirmationText: {
		marginLeft: '5%',
		fontSize: largeTextSize,
		fontWeight: '600',
		color: '#4E4E4E',
	},
	mainHeader: {
		fontSize: titleTextSize,
		textAlign: 'center',
		fontWeight: '600',
	},
	buttonContainer: {
		alignItems: 'center',
		width: '100%',
	},
	doneButton: {
		backgroundColor: 'grey',
		borderRadius: 12,
		paddingVertical: 20,
		width: '100%',
		alignItems: 'center',
		justifyContent: 'center',
	},
	buttonText: {
		color: Colors.custom.restaurantMainText,
		fontSize: largeTextSize,
		fontWeight: 'bold',
	},
})
